import Section from "./Section";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

const SectionsContainer = ({
  sections,
  onEditSection,
  templateName,
  onDeleteSection,
  onEditInput,
  onDeleteInput,
  setSectionNameModal,
  getAllFunnel,
  selectedfunnel,
  setSelectedFunnel,
  templateId,
  isDeployed,
  handleEditSection,
}) => {
  return (
    <>
      {/* {sections?.length === 0 && <h2 className="text-center">No sections found</h2>} */}
      {/* {console.log(isDeployed, "getAllFunnel section continer")} */}
      {sections?.length > 0 && (
        <Droppable droppableId="SECTIONS" type="SECTION">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {sections?.map((section, index) => (
                <Section
                  key={section.sectionId}
                  is_locked={section?.is_locked}
                  section={section}
                  templateName={templateName}
                  index={index}
                  onEditSection={onEditSection}
                  onDeleteSection={onDeleteSection}
                  onEditInput={onEditInput}
                  onDeleteInput={onDeleteInput}
                  getAllFunnel={getAllFunnel}
                  selectedfunnel={selectedfunnel}
                  setSelectedFunnel={setSelectedFunnel}
                  isDeployed={isDeployed}
                  templateId={templateId}
                  handleEditSection={handleEditSection}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      )}

      {/* <div
        onClick={() => setSectionNameModal(true)}
        className="flex justify-center border-2 min-h-[100px] group items-center border-dashed border-indigo-400 cursor-pointer rounded-md"
      >
        <p className="text-gray-600 group-hover:text-indigo-400">+ Add Section</p>
      </div> */}
    </>
  );
};

export default SectionsContainer;
